import { Report } from '@activity/report'
import { browserDetect } from '@activity/utils'
import { throwError } from '../utils'

let $report: (
  data: { name: string; [key: string]: unknown },
  topic?: 'sdk_h5_event' | 'sdk_h5',
  timeout?: number
) => Promise<void>

export const createReport = () => {
  const appid = window.appId

  let reportExternalOptions = {
    // source: getUrlParam("source"),
  }

  /* let eventid = ''
  switch (window.lang) {
    case 'ja':
      eventid = '100000138'
      break

    default:
      eventid = '0'
      break
  } */
 const eventid = window.eventid

  const reporter = Report.create(
    Object.assign(
      {
        eventid,
        appid,
        lang: 'en',
        platform: browserDetect.OS.toLowerCase(),
      },
      reportExternalOptions
    )
  )

  $report = (data, topic = 'sdk_h5_event', timeout = 5000) =>
    reporter(data, {
      topic,
      debug: process.env.ENV !== 'production',
      timeout,
    }).catch((err: unknown) => {
      throwError(err)
    })
}

export default () => $report
